import { render } from "./GameHistory.vue?vue&type=template&id=013c5f8a&scoped=true"
import script from "./GameHistory.js?vue&type=script&lang=js"
export * from "./GameHistory.js?vue&type=script&lang=js"

import "./GameHistory.scss?vue&type=style&index=0&id=013c5f8a&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Mariana Costa\\MyProjects\\lets-play\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-013c5f8a"]])

export default __exports__